import React, { useEffect, useState } from 'react';
import { fetchAlerts, resolveAlert } from '../utils/api';
import './Alerts.css';

const typeColors = {
  'SOS': '#ef4444', 'Panic': '#f97316', 'Low Battery': '#f59e0b',
  'Device Offline': '#64748b', 'System': '#22c55e', 'Patrol Assigned': '#3b82f6'
};

const typeIcons = {
  'SOS': '🆘', 'Panic': '🔔', 'Low Battery': '🔋',
  'Device Offline': '📵', 'System': '✅', 'Patrol Assigned': '🚔'
};

const Alerts = () => {
  const [alerts, setAlerts] = useState([]);

  const load = async () => {
    try {
      const res = await fetchAlerts();
      setAlerts(res.data.alerts);
    } catch { setAlerts([]); }
  };

  useEffect(() => { load(); const t = setInterval(load, 10000); return () => clearInterval(t); }, []);

  const resolve = async (id) => {
    await resolveAlert(id, { resolvedBy: 'Command Center' });
    load();
  };

  const demoAlerts = [
    { _id: '1', type: 'SOS', message: 'SOS triggered by Officer Sai Kiran at MG Road', createdAt: new Date(Date.now() - 120000), officer: 'Sai Kiran', location: 'MG Road' },
    { _id: '2', type: 'SOS', message: 'SOS triggered at Benz Circle', createdAt: new Date(Date.now() - 240000), location: 'Benz Circle' },
    { _id: '3', type: 'Panic', message: 'Panic alert from Officer Prasad Naidu', createdAt: new Date(Date.now() - 360000), officer: 'Prasad Naidu' },
    { _id: '4', type: 'Low Battery', message: 'Baton VJW-0010 battery at 15%', createdAt: new Date(Date.now() - 1500000) },
    { _id: '5', type: 'Device Offline', message: '12 devices currently offline', createdAt: new Date(Date.now() - 3600000) },
    { _id: '6', type: 'System', message: 'All systems operational', createdAt: new Date(Date.now() - 600000) },
    { _id: '7', type: 'Patrol Assigned', message: 'New patrol assigned – MG Road', createdAt: new Date(Date.now() - 1200000) },
  ];

  const displayAlerts = alerts.length > 0 ? alerts : demoAlerts;

  return (
    <div className="alerts-page">
      <div className="page-header">
        <h2>Alerts &amp; Notifications</h2>
        <span className="alert-total">{displayAlerts.length} active</span>
      </div>
      <div className="alerts-list">
        {displayAlerts.map(a => (
          <div key={a._id} className={`alert-card ${a.type.toLowerCase().replace(' ', '-')}`}>
            <div className="alert-type-icon">{typeIcons[a.type] || '🔔'}</div>
            <div className="alert-body">
              <div className="alert-type" style={{ color: typeColors[a.type] }}>{a.type}</div>
              <div className="alert-message">{a.message}</div>
              {a.location && <div className="alert-meta">📍 {a.location}</div>}
            </div>
            <div className="alert-right">
              <div className="alert-time">{new Date(a.createdAt).toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' })}</div>
              <button className="resolve-btn" onClick={() => resolve(a._id)}>Resolve</button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Alerts;
